import { Recurrence } from '@tableau/self-service-schedules';
import { SelfServiceSchedulePane } from '@tableau/self-service-schedules/lib/src/components/SelfServiceSchedulePane';
import { DropdownButtonType, List, ListItem, SingleSelectDropdown } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';

import { ReactActionDialogBodyProps } from '../../commonInfra/dialogs/ReactActionDialog';
import { SubscriptionFrequency } from './SchedulePickerActionBody';

export interface SelfServiceScheduleSubscriptionDialogState {
  recurrence: Recurrence;
  selectedSubscriptionFrequency?: SubscriptionFrequency;
}

export type PropsForSelfServiceScheduleSubscriptionDialogBody = ReactActionDialogBodyProps<{}, SelfServiceScheduleSubscriptionDialogState>;

export function SelfServiceScheduleSubscriptionDialogBody(props: PropsForSelfServiceScheduleSubscriptionDialogBody): JSX.Element {
  const scheduleOptions: ListItem[] = [
    {
      value: SubscriptionFrequency.onSelectedSchedule,
      content: Messages.changeSubscriptionsFrequencyOptionOnSelectedSchedule(),
    },
    {
      value: SubscriptionFrequency.onExtractRefresh,
      content: Messages.changeSubscriptionsFrequencyOptionOnExtractRefresh(),
    }
  ];
  const dropdown = <SingleSelectDropdown
    label=''
    list={<List items={scheduleOptions} />}
    type={DropdownButtonType.Outline}
    onChange={(value: SubscriptionFrequency) => props.updateDialogState({ selectedSubscriptionFrequency: value })}
    value={props.dialogState.selectedSubscriptionFrequency}
  />;
  return <>
    {props.dialogState.selectedSubscriptionFrequency && dropdown}
    {props.dialogState.selectedSubscriptionFrequency !== SubscriptionFrequency.onExtractRefresh && <SelfServiceSchedulePane
      recurrenceModel={props.dialogState.recurrence}
      recurrenceModelChangedCallback={(recurrence) => props.updateDialogState({ recurrence })}
    />}
  </>;
}
